import { SvgIconComponent } from '@mui/icons-material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined';
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import CampaignOutlined from '@mui/icons-material/CampaignOutlined';

export const LEARN_IS_HIDDEN = false;

export interface LearnLesson {
  title: string;
  description: string;
  /** Synthesia embed URL. */
  url: string;
}

export interface LearnSection {
  title: string;
  icon: SvgIconComponent;
  /** Sections with no lessons yet stay hidden. */
  lessons: LearnLesson[];
}

const SYNTHESIA_EMBED = 'https://share.synthesia.io/embeds/videos';

export const LEARN_SECTIONS: LearnSection[] = [
  {
    title: 'Learn the basics',
    icon: InfoOutlined,
    lessons: [
      {
        title: 'Basic navigation',
        description:
          'See how to find the calendar, customers, checkout and settings from anywhere in Porter.',
        url: `${SYNTHESIA_EMBED}/908318d0-d8a3-4330-93a5-0de74000c278`,
      },
      {
        title: 'Book an appointment',
        description:
          'Add a client, pick an artist and time, and take a deposit in one pass through the composer.',
        url: `${SYNTHESIA_EMBED}/dfe6f5f2-7e04-41e6-8a12-df6a3548c524`,
      },
    ],
  },
  {
    title: 'Set up your shop',
    icon: StorefrontOutlined,
    lessons: [
      {
        title: 'Add an artist',
        description:
          'Invite artists, set their working hours, and decide what they can see in your calendar.',
        url: `${SYNTHESIA_EMBED}/cedb63ee-b0a2-4b4c-9cca-0a18ffc66269`,
      },
      {
        title: 'Default artist settings',
        description:
          'Set the booking, deposit and payout defaults every new artist starts with.',
        url: `${SYNTHESIA_EMBED}/e9cc0315-41aa-4624-b93e-293b532c36eb`,
      },
      {
        title: 'Add a service',
        description:
          'Set up the services your shop offers, with default length, price and deposit.',
        url: `${SYNTHESIA_EMBED}/8d8170d6-0ffd-4585-ba45-7caa26ddd652`,
      },
      {
        title: 'Add a retail item',
        description:
          'Build a catalog of aftercare products and merch so checkout stays quick.',
        url: `${SYNTHESIA_EMBED}/9dbceffe-821f-493a-9004-1a01090e0bfe`,
      },
      {
        title: 'Decide which terminal option is right for you',
        description:
          'Compare the card reader options and pick the one that fits your front desk.',
        url: `${SYNTHESIA_EMBED}/501312b0-9078-43a0-89e6-ab554759c33a`,
      },
    ],
  },
  {
    title: 'Fill your calendar',
    icon: CalendarMonthOutlined,
    lessons: [],
  },
  {
    title: 'Grow your shop',
    icon: CampaignOutlined,
    lessons: [],
  },
];
